import { graphql } from "../../gql/gql";

export const SIGN_UP = graphql(`
  mutation SignUp($data: SignUpInput!) {
    signUp(data: $data) {
      id
    }
  }
`);

export const SIGN_IN = graphql(`
  mutation SignIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      accessToken
    }
  }
`);

export const SING_IN_WITH_CODE = graphql(`
  mutation SignInWithCode($code: String!) {
    signInWithCode(code: $code) {
      accessToken
    }
  }
`);

export const USER_INVITE = graphql(`
  mutation UserInvite($email: String!) {
    userInvite(email: $email) {
      email
    }
  }
`);

export const USER_UPDATE = graphql(`
  mutation UserUpdate($data: UserUpdateInput!) {
    userUpdate(data: $data) {
      id
    }
  }
`);

export const USER_UPDATE_PASSWORD = graphql(`
  mutation UserUpdatePassword($data: UserUpdatePasswordInput!) {
    userUpdatePassword(data: $data) {
      id
    }
  }
`);

export const USER_DELETE = graphql(`
  mutation UserDelete($userId: String!) {
    userDelete(userId: $userId) {
      id
      email
    }
  }
`);

export const USER_DELETE_CURRENT = graphql(`
  mutation UserDeleteCurrent {
    userDeleteCurrent {
      id
    }
  }
`);

export const USER_REQUEST_PASSWORD_RESET = graphql(`
  mutation userRequestPasswordReset($email: String!, $token: String!) {
    userRequestPasswordReset(email: $email, token: $token)
  }
`);

export const STRIPE_CHECKOUT_CREATE = graphql(`
  mutation StripeCheckoutCreate($priceId: String!) {
    stripeCheckoutCreate(priceId: $priceId) {
      id
    }
  }
`);

export const USER_RESEND_INVITATION = graphql(`
  mutation UserResendInvitation($userId: String!) {
    userResendInvitation(userId: $userId) {
      email
    }
  }
`);

export const USER_GRANT_ADMIN = graphql(`
  mutation UserGrantAdmin($userId: String!) {
    userGrantAdmin(userId: $userId) {
      email
      role
    }
  }
`);

export const USER_REVOKE_ADMIN = graphql(`
  mutation UserRevokeAdmin($userId: String!) {
    userRevokeAdmin(userId: $userId) {
      email
      role
    }
  }
`);

export const STRIPE_PORTAL_SESSION_CREATE = graphql(`
  mutation StripePortalSessionCreate {
    stripePortalSessionCreate {
      url
    }
  }
`);
